import React from "react"

import perksImgSrc from "@irati/ui/images/perks2.png"
import {H5} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import {PerksImage, Card} from "./styled"

const UserOnboardingSideBar = () => (
  <Card>
    <H5>
      <FormattedMessage id="onboarding.sideBar.header" />
    </H5>
    <PerksImage src={perksImgSrc} />
  </Card>
)

export default UserOnboardingSideBar
